import { c, h1Style, ledeStyle } from '../tokens';
import './catalog-page-header.css';
import './catalog-create-button.css';

export function CatalogPageHeader({ title, description, action, onCreate }: {
  title: string;
  description: string;
  action: string;
  onCreate: () => void;
}) {
  return <header className="catalog-page-heading" style={{ color: c.text }}>
    <div className="catalog-page-heading-copy">
      <h1 style={h1Style}>{title}</h1>
      <p style={ledeStyle}>{description}</p>
    </div>
    <button type="button" className="catalog-create-button skill-create-button" onClick={onCreate}>
      + {action}
    </button>
  </header>;
}
